var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVatUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 14.5C3 14.5 2 14.5 2 13.4167C2 12.3333 3 9.08333 8 9.08333C13 9.08333 14 12.3333 14 13.4167C14 14.5 13 14.5 13 14.5H3ZM8 8C8.79565 8 9.55871 7.65759 10.1213 7.0481C10.6839 6.4386 11 5.61195 11 4.75C11 3.88805 10.6839 3.0614 10.1213 2.4519C9.55871 1.84241 8.79565 1.5 8 1.5C7.20435 1.5 6.44129 1.84241 5.87868 2.4519C5.31607 3.0614 5 3.88805 5 4.75C5 5.61195 5.31607 6.4386 5.87868 7.0481C6.44129 7.65759 7.20435 8 8 8Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatUser);
export default __webpack_public_path__ + "static/media/vat-user.515ed9ed858bf2d41820a94a0a0d89ef.svg";
export { ForwardRef as ReactComponent };